import { add } from 'date-fns';
import { convertDateToTimeZone } from '../../../../utils/convertDateToTimeZone';

export function getMinimumEntryDate(minimumOffsetInSeconds: number) {
	const currentTime = convertDateToTimeZone(new Date());

	// Add the offset in seconds
	const minimumEntryTime = add(currentTime, {
		seconds: minimumOffsetInSeconds,
	});

	return minimumEntryTime;
}
